import { render, staticRenderFns } from "./DialogoMarcas.vue?vue&type=template&id=2972d079&"
import script from "./DialogoMarcas.vue?vue&type=script&lang=js&"
export * from "./DialogoMarcas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports